import { useEffect, useState } from "react";
import { useIsVerified } from "src/components/email-verification";
import {
  MainCard,
  MainCardContent,
  MainCardTitle,
} from "src/components/main-card-type.tsx";
import { Button } from "src/components/ui/button";
import {
  checkCalculatorUsageLimitAndRedirect,
  loadSavedCalculatorData,
  saveCalculatorData,
} from "src/utils/functions";
import { ContadorDiasResponse } from "../Contador-dias";
const calculatorKey = "contador-dias";

export const ContadorInputCard = ({
  setResults,
}: {
  setResults: (value: ContadorDiasResponse | null) => void;
}) => {
  const isVerified = useIsVerified();
  const [message, setMessage] = useState<string>("");
  const [dataInicio, setDataInicio] = useState("");
  const [dataFinal, setDataFinal] = useState("");

  function clear() {
    setDataInicio("");
    setDataFinal("");
  }
  function handleSave() {
    saveCalculatorData(calculatorKey, {
      dataInicio,
      dataFinal,
    });
  }
  useEffect(() => {
    const savedData = loadSavedCalculatorData(calculatorKey);
    if (!savedData) return;
    setDataInicio((savedData.dataInicio as string) || "");
    setDataFinal((savedData.dataFinal as string) || "");
  }, []);

  function dataAtualInicial() {
    const today = new Date();

    const dia = String(today.getDate()).padStart(2, "0");
    const mes = String(today.getMonth() + 1).padStart(2, "0");
    const ano = String(today.getFullYear());

    const dataFormatada = `${ano}-${mes}-${dia}`;

    setDataInicio(dataFormatada);
  }
  function dataAtualFinal() {
    const today = new Date();

    const dia = String(today.getDate()).padStart(2, "0");
    const mes = String(today.getMonth() + 1).padStart(2, "0");
    const ano = String(today.getFullYear());

    const dataFormatada = `${ano}-${mes}-${dia}`;

    setDataFinal(dataFormatada);
  }
  function calcular() {
    if (!dataInicio) {
      setMessage("Adcione uma data Inicial");
      setResults(null);
      return;
    }
    if (!dataFinal) {
      setMessage("Adcione uma data Final");
      setResults(null);
      return;
    }

    const inicio = new Date(dataInicio);
    const fim = new Date(dataFinal);

    let milisegundos = fim.getTime() - inicio.getTime();

    let Dias: number = milisegundos / (1000 * 60 * 60 * 24);
    let Semana: number = Math.floor(Dias / 7);

    let Mes: number = Math.floor(Dias / 30);

    let Ano: number = Dias / 365.25;

    if (Ano < 1) {
      Ano = 0;
    }
    Ano = Math.floor(Ano);

    const diasSemana = [
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado",
      "Domingo",
    ];

    let diaSemana: string = diasSemana[fim.getDay()];

    const resultado = {
      Dias: Dias,
      Semana: Semana,
      Mes: Mes,
      Ano: Ano,
      diaSemana: diaSemana,
    };
    setResults(resultado);
  }

  return (
    <MainCard>
      <MainCardTitle>Contador de dias</MainCardTitle>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
          checkCalculatorUsageLimitAndRedirect(calcular);
        }}
      >
        <MainCardContent>
          <div className="relative">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="bruto-id"
            >
              Data ínicio
            </label>
            <button
              onClick={dataAtualInicial}
              type="button"
              className="inline-flex items-center px-3 absolute -top-1.5  right-0 py-1.5 border-r text-sm bg-[#e9ecef] hover:bg-gray-400 rounded-sm"
            >
              Data Atual
            </button>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="mm/dd"
                type="date"
                value={dataInicio}
                onChange={(event) => setDataInicio(event.target.value)}
              />
            </div>
          </div>
          <div className="relative">
            <label
              className="block mb-2 font-medium text-sm"
              htmlFor="bruto-id"
            >
              Data Final
            </label>
            <button
              onClick={dataAtualFinal}
              type="button"
              className="absolute right-0 -top-1.5 inline-flex items-center px-3 py-1.5 border-r text-sm bg-[#e9ecef] hover:bg-gray-400 rounded-sm"
            >
              Data Atual
            </button>
            <div className="flex border">
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="mm/dd"
                type="date"
                value={dataFinal}
                onChange={(event) => setDataFinal(event.target.value)}
              />
            </div>
          </div>
        </MainCardContent>
        <div className="flex justify-between">
          <Button
            disabled={!isVerified}
            type="submit"
            variant={"default"}
            className="sm:w-[150px]"
          >
            Calcular
          </Button>

          <div className="flex flex-col sm:flex-row items-center gap-2">
            <Button onClick={clear} type="button" variant={"ghost"}>
              Limpar
            </Button>
          </div>
        </div>
      </form>
      <p className="text-red-800 text-center mt-2 font-bold">{message}</p>
    </MainCard>
  );
};
